import React, { Component } from 'react'
import TimeField from 'vendor/time-field'
import DropdownMenu from 'components/dropdown-menu/dropdown-menu'
import { debounce } from 'lodash'
import Button from 'components/button/button'
import { connect } from 'react-redux'

import { 
    searchTasks, 
    addManualSession,
    openModal 
} from 'state/actions'
import { getCurrentAccount } from 'state/selectors'

import {
    getSessionsFromTimeInput
} from 'utils'

class ModalAddTime extends Component {
    state = {
        taskNameTextValue: '',
        timeValue: '',
        searchResults: [],
        selectedItemId: null
    }

	constructor(props){
		super(props)

		this.debouncedSearchTasks = debounce(this.searchTasks, 300)
	}

    handleChange = (value, key) => {
        this.setState({
            [key]: value
        })
    }

    searchTasks = value => {
        const { searchTasks, currentAccount } = this.props

        if(value.length > 2){
            searchTasks(currentAccount.id, value, searchResults => {
                const includedProjectIds = Object.keys(window.allIncludedProjects)

                const visibleTasks = searchResults.filter(task => {
                    return ~includedProjectIds.indexOf(task.project_id+'')
                })

                this.setState({
                    searchResults: visibleTasks
                })
            })
        }
    }

    selectTask = taskId => {
        this.setState({
            selectedItemId: taskId
        })
    }

    handleSubmit = _ => {
        const { 
            setLoading, 
            addManualSession, 
            data: {
                date
            },
            openModal
        } = this.props

        const { 
            timeValue,
            selectedItemId
        } = this.state

        const totalSeconds = getSessionsFromTimeInput(timeValue)

        setLoading(true)

        addManualSession(selectedItemId, totalSeconds, date.format('YYYY-MM-DD'), () => {

			openModal('confirm', 'confirm', {
				text: `We've added this time-tracking session in for you.`
			})

            setLoading(false)
        })
    }

    handleSearchTermChange = value => {
        this.debouncedSearchTasks(value)
    }

    canSubmit = _ => {
        const {
            timeValue,
            selectedItemId
        } = this.state

        return selectedItemId && timeValue && timeValue !== '00:00'
    }

    render() {
        const {
            timeValue,
            searchResults,
            selectedItemId
        } = this.state

        const {
            closeCallback
        } = this.props

        return (
			<div>
                <h2>
                    Add manual time
                </h2>
				<div className={'borders'}>
                    <div>
                        <DropdownMenu 
                            parentType="task"
                            parentKey="task_id"
                            selectableItems={searchResults}
                            isObjects={true}
                            selectedItemId={selectedItemId}
                            handleChange={this.selectTask}
                            handleSearchTermChange={this.handleSearchTermChange}
                            hasSearch={true}
                        />
                    </div>
					<TimeField
						onChange={value => this.handleChange(value, 'timeValue')}
						value={timeValue}
                        placeholder={'00:00'}
						colon=":"
					/>
                </div>
				<Button 
					size={'big'} 
					level={'high'} 
					callback={this.handleSubmit} 
					label={'Save'} 
					icon={'check'} 
					disabled={!this.canSubmit()}
				/>
				<Button 
					size={'big'} 
					level={'low'} 
					callback={closeCallback} 
					label={'Cancel'} 
				/>
            </div>
        )
    }
}



const mapStateToProps = state => {
	return {
        currentAccount: getCurrentAccount(state),
    }
}

export default connect(mapStateToProps, {
    searchTasks,
    addManualSession,
    openModal
})(ModalAddTime)